import Creditos from "../Creditos";
const Portada = (props) => {
  const { elementoIntroduccion } = props;
  return (
    <div className="h-screen bg-azul-1d relative">
      <Creditos/>
      <div className=" titulo-portada">
        <div className="absolute top-0 left-0">
          <img className=" lg:w-80 lg:mt-5" src={require(`../../images/logo-fundacion-terpel.svg`).default} alt="logo terpel" />
        </div>
        <img
          alt="logo design for change"
          className="w-9/12 mx-auto md:w-6/12  lg:w-5/12 "
          src={require(`../../images/logo-portada.png`).default}
        />
      </div>
      <div className=" imagen-portada h-full  img-cover-center">
      </div>

      <div className="absolute bottom-0 fondo-portada center w-full h-48">
        <button
          className="text-28 text-blanco mt-10"
          onClick={() => {
            let link = elementoIntroduccion.current;
            document.getElementsByTagName('html')[0].scrollTop = link.offsetTop;
          }}
        >
          <p className="poppins-700 md:poppins-700">Leer</p>
          <span className="icon-abajo"></span>
        </button>
      </div>
    </div>
  )
}

export default Portada;
